// iframe-popup.js
(function(){
  // only run once
  if (window.iframePopupInitialized) return;
  window.iframePopupInitialized = true;

  // cache elements
  var $modal     = $('#iframe-modal');
  var $popup     = $('.iframe-popup');
  var $watchMore = $('.watch-more');
  var $closeIcon = $popup.find('.close');
  var $iframe    = $popup.find('iframe');
  var originalSrc = $iframe.data('src');


  // pull the clean URL from data-src (or fallback to src)
  var originalSrc = $iframe.data('src') || $iframe.attr('src');
  $iframe.data('src', originalSrc);

  function openPopup(e) {
  e.preventDefault();
  var sep = originalSrc.includes('?') ? '&' : '?';
  $iframe.attr('src', originalSrc + sep + 'autoplay=1');
  $modal.add($popup).fadeIn(200);
  $('body').addClass('overlay-active');
}


  function closePopup() {
  // wipe it out so no autoplay flag lingers
  $iframe.attr('src','');
  $modal.add($popup).fadeOut(200);
  $('body').removeClass('overlay-active');
}


  // bind handlers
  $watchMore.on('click', openPopup);
  $closeIcon.on('click', function(e){
    e.preventDefault();
    closePopup();
  });

  // click-outside to close
  $modal.on('click', function(e){
    if (e.target === this) closePopup();
  });

  // Esc to close
  $(document).on('keyup', function(e){
    if (e.key === 'Escape') closePopup();
  });
})();
